export const dropdownProps = {
  width: {
    type: Number,
    default: 100,
  },
  dropWidth: {
    type: Number,
    default: 0,
  },
  dropBackground: {
    type: String,
    default: '',
  },
  selectValue: {
    type: String,
    default: '',
  },
  dropTop: {
    type: Number,
    default: 56
  }
}

export const dropdownEmit = {
  optionClick: (_value: { value: string, label: string}) => _value,
  optionUpdate: () => true,
}